<template>
  <div>
      <tooltip label="Contacts" type="default" placement="left">
      <a class="button button-table is-small" @click="contact()">
        <i class="fa fa-address-card"></i>
      </a>
    </tooltip>
    <tooltip label="Edit" type="default" placement="left">
      <a class="button button-table is-small" @click="edit()">
        <i class="fa fa-pencil"></i>
      </a>
    </tooltip>
     <tooltip label="Comments" type="default" placement="left">
      <a class="button button-table is-small" @click="comments()">
        <i class="fa fa-comment-o"></i>
      </a>
    </tooltip>
    <!--<tooltip label="Rules" type="default" placement="left">
      <a class="button button-table is-small" @click="editRules()">
        <i class="fa fa-cog"></i>
      </a>
    </tooltip> -->

    <!-- <tooltip label="Finances" type="default" placement="left">
      <a class="button button-table is-small" @click="finances()">
        <i class="fa fa-usd"></i>
      </a>
    </tooltip>
    <tooltip label="Relationship" type="default" placement="left">
      <a class="button button-table is-small" @click="relationship()">
        <i class="fa fa-handshake-o"></i>
      </a>
    </tooltip> -->
    <!-- <tooltip label="Call Log" type="default" placement="left">
      <a class="button button-table is-small" @click="call()">
        <i class="fa fa-phone"></i>
      </a>
    </tooltip> -->
    <tooltip label="Verified" type="default" placement="right" v-if="parseInt(data.verified) === 0">
        <a class="button button-table is-small" @click="verified">
          <i class="fa fa-check"></i>
        </a>
    </tooltip>
  </div>
</template>

<script>
  import Tooltip from 'vue-bulma-tooltip'
  import Message from '../../utils/message'
  import Hotel from './hotel'
  import Contact from '../customer/contact'
  import Call from '../customer/call'
  import Comment from '../customer/comment'
  export default {
    data () {
      return {}
    },
    props: {
      data: {
        type: Object,
        required: true
      }
    },
    components: {
      Tooltip
    },
    methods: {
      edit () {
        let propsData = {
          context: this,
          hotel_id: this.data.id,
          title: 'Edit Hotel',
          callback: 'hotelCallback'
        }
        Hotel.openHotel(propsData)
      },
      hotelCallback (result) {
        let propsData = null
        if (result.ok) {
          propsData = {
            title: 'Success',
            message: result.message,
            type: 'success',
            direction: 'down',
            duration: 4500,
            showCloseButton: true
          }
          this.$parent.loadData()
        }
        Message.openMessage(propsData)
      },
      contact () {
        let propsData = {
          context: this,
          hotel_id: this.data.id,
          title: 'Hotel - ' + this.data.name,
          callback: 'hotelCallback'
        }
        Contact.openContacts(propsData)
      },
      verified () {
        this.$http.post(this.$store.state.config.apiURL + '/hotels/verified', { id: this.data.id }).then((response) => {
          this.message('success', 'Success', 'The hotel ' + this.data.name + ' was successfully checked')
          this.$parent.loadData()
        }, (response) => {
          this.message('danger', 'Error', response.body.message)
          this.$parent.loadData()
        })
      },
      call () {
        let propsData = {
          context: this,
          hotel_id: this.data.id,
          title: 'Hotel - ' + this.data.name,
          callback: 'hotelCallback'
        }
        Call.openCallLogs(propsData)
      },
      comments () {
        let propsData = {
          context: this,
          hotel_id: this.data.id,
          title: 'Hotel - ' + this.data.name,
          callback: 'hotelCallback'
        }
        Comment.openComments(propsData)
      },
      message (type, title, content) {
        let propsData = {
          title: title,
          message: content,
          type: type,
          direction: 'down',
          duration: 4500,
          showCloseButton: true
        }
        Message.openMessage(propsData)
      }
    }
  }
</script>

<style lang="scss">
  .button-table {
    padding-top: 6px;
  }
</style>



// WEBPACK FOOTER //
// HotelTableButtons.vue?81f25000